// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__Q0x-1","noInteraction":"EventWrapper_noInteraction__2S-Gu","pointerPassthrough":"EventWrapper_pointerPassthrough__vGasr"};